import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-authoring-view-content',
  templateUrl: './authoring-view-content.component.html',
  styleUrls: ['./authoring-view-content.component.scss']
})
export class AuthoringViewContentComponent implements OnInit {

  adminData:any;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  content_capsule_id :any;data={};contentDetailsData:any;contentDetailsMediaData:any=[];
  closeResult: any = '';tab:any;
  content_capsule_ids:any='';
  constructor(private contentAuthoringApi:ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,public modalService: NgbModal) { }

  ngOnInit(): void {
    this.spinner.show();
    this.route.queryParams.subscribe(queryParams => {
    this.content_capsule_id = queryParams['id'];
    this.tab = queryParams['tab'];
    this.getContentAuthDetails(this.content_capsule_id);
    });
    
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
  }
  getContentAuthDetails(content_capsule_id:any){
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
      (data)=>{
      if(data.success){
        this.spinner.hide();
        this.contentDetailsData=data.data; 
        this.contentDetailsMediaData=data.data.contentCapsuleMedia; 
       // console.log(this.contentDetailsData);
      }else{
        this.spinner.hide();
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'No data Exist'
      }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
       },
    );
  }
  getMediaType(mediatypeArr:any,media_type:any){
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
    
  }
  open(content: any,content_capsule_id:any) {
    //this.tabName = tab_name;
    this.content_capsule_ids = content_capsule_id;
    this.modalService.open(content, { size: 'sm',centered: true  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    //this.succesDelAssessment = false;
    //.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  changeIsDeActiveVal(capsule_id: any,is_actives:any) {
    this.changeIsActiveVal(capsule_id,is_actives);
   }
   changeIsActiveVal(content_capsule_id: any,is_active:any){
    this.contentAuthoringApi.changeIsActiveVal(content_capsule_id,is_active).subscribe(
      (data)=>{
       // console.log(data);
        if(data.status == 200){
          document.getElementById('closelId')?.click();
          this.getContentAuthDetails(this.content_capsule_ids);
          //this.router.navigate(['/authoring_viewContent'], { queryParams: { id: this.content_capsule_ids } });
        }else{
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'No data Exist'
      }
      },
      (error) => { 
        this.errorInfo.errorMsg = error;
       },
    );
  }
  logout(){
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   } 
   /*******create duplicate content capsule  *****/
  duplicateCapsule(capsule_id: any) {
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(capsule_id).subscribe(
      (data) => {
        if (data.status == 200) {
          this.contentDetailsData = data.data;
          this.contentDetailsData['capsule_name'] = this.contentDetailsData.capsule_name + '-copy';
          this.contentDetailsData['capsules_status'] = 1;
          delete this.contentDetailsData['content_capsule_id'];
          this.contentDetailsData['created_by']='1';
          delete this.contentDetailsData['created_dttm'];
          // if(tab_name =='Deactivated'){
          //   this.contentDetailsData['is_active'] = 0;
          // }
           let arr = this.contentDetailsData.contentCapsuleMedia;
           for (let n = 0; n < arr.length; n++) {
             
            if(arr[n]['media_type'] === 2 ){
              this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
                arr[n]['media_path'] = dataURL;
              });
           } 
           if(arr[n]['media_type'] === 3 ){
            this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
              arr[n]['media_path'] = dataURL;
            });
          }
            delete arr[n]['content_capsule_id'];
            delete arr[n]['created_by'];
            delete arr[n]['created_dttm'];
            delete arr[n]['content_capsule_media_id'];
            delete arr[n]['modified_dttm'];
            delete arr[n]['sort_order'];
            delete arr[n]['is_active'];
           }
          setTimeout(() => {
          this.saveDuplicateCapsule(this.contentDetailsData);
          }, 10000);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  /************duplicate create content authoring (capsule) *******/
  saveDuplicateCapsule(contentAuthForm: any) {
     this.contentAuthoringApi.upload(contentAuthForm,'create').subscribe(
       (data) => {
         if (data.status == 201 || data.status == 200) {
           document.getElementById('closelId')?.click();
           this.spinner.hide();
         } else {
           this.spinner.hide();
           this.errorInfo.isError = true;
           this.errorInfo.errorMsg = 'Something went wrong.'
         }
       },
       (error) => {
         this.spinner.hide();
         this.errorInfo.errorMsg = error;
       },
     );
   }
   /************ convert image, video url in base64  *****/
  toDataURL(src: any, callback: any) {
    let xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
      let fileReader = new FileReader();
      fileReader.onloadend = function () {
        callback(fileReader.result);
      }
      fileReader.readAsDataURL(xhttp.response);
    }
    xhttp.responseType = 'blob';
    xhttp.open('GET', src, true);
    xhttp.send();
  }
}
